import React, { Component } from 'react';

import FullTextSearch from './FullTextSearch';

import CommonSubeader from '../../SubHeader';

import './SubHeader.css';
import { observer, inject } from 'mobx-react';

import { CloseIcon, UpdateIcon } from '../../../../common/icons';

@inject('carsStore', 'translationsStore', 'filterStore')
@observer
export default class SubHeader extends Component {
  render() {
    const { translationsStore } = this.props;
    return (
      <CommonSubeader cars={this.props.carsMap}>
        <FullTextSearch onClearFullTextSearch={this.props.onClearFullTextSearch} onFullTextSearch={this.props.onFullTextSearch} />
        <div className="resetAggiorna">
          <div className="reset">
            <div className="icon" onClick={() => this.props.onResetFilters()}>
              <CloseIcon />
            </div>
            <div className="label">{translationsStore.translate('reset')}</div>
          </div>
          <div className="aggiorna">
            <div className="icon" onClick={() => this.props.onReload()}>
              <UpdateIcon />
            </div>
            <div className="label">{translationsStore.translate('update')}</div>
          </div>
        </div>
      </CommonSubeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Dashboard/SubHeader/SubHeader.js